import { render, staticRenderFns } from "./ServiceRequestAttachment.vue?vue&type=template&id=3662360b&scoped=true"
import script from "./ServiceRequestAttachment.vue?vue&type=script&lang=js"
export * from "./ServiceRequestAttachment.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestAttachment.vue?vue&type=style&index=0&id=3662360b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3662360b",
  null
  
)

export default component.exports